package app.nestbridge.feature.invitations.api.model

import kotlinx.serialization.Serializable

@Serializable
enum class InvitationStatusDto {
    PENDING,
    ACCEPTED,
    DECLINED,
    EXPIRED,
}

@Serializable
enum class OrganizationTypeDto {
    EARLY_INTERVENTION,
    PRIVATE_PRACTICE,
    SCHOOL_BASED,
    DAYCARE,
    ABA_CENTER,
    OTHER,
}

@Serializable
enum class InvitationDeliveryMethodDto {
    EMAIL,
    PHONE,
}
